import { OverviewState, useOverviewLinkState } from '../linkstate/ReportsOverview.linkstate';

export const useOverviewLinkStateActions = () => {
    const [state, setState] = useOverviewLinkState();
    return {
        patch: (patch: Partial<OverviewState>) => setState({ ...state, ...patch }),
    };
};
